import React from 'react';
import { observer } from 'mobx-react';

import { Divider } from 'ui';

import UploadedFileItem from './UploadedFileItem';

interface Props {
  files?: IUploadedFile[];
  onRemove: (file: IUploadedFile) => void;
}

function UploadedFileList({ files, onRemove }: Props) {
  if (files === undefined || files.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      {files.map((file, index) => (
        <React.Fragment key={file.id}>
          <UploadedFileItem key={file.id} file={file} onRemove={() => onRemove(file)} />
          {files.length > 1 && index !== files.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </div>
  );
}

export default observer(UploadedFileList);
